<template>
  <app-page-container :showNav="true">
    <div class="section">
      <div class="section-info">
        <div class="instruction-title">Use cases</div>
        <div class="cofocus-info">There's only one question.</div>
        <div class="cofocus-info">Is there anything you need to get done?</div>
      </div>
      <div class="explanations flex">
        <div class="explanation-block">
          <div class="explanation">
            <div class="explanation-header flex">
              <div class="explanation-title">Read</div>
            </div>
            <div class="explanation-description">
              That never ending reading list of yours is about to get shorter.
              Carve out dedicated blocks to sit down & do some serious page
              turning.
            </div>
          </div>
        </div>
        <div class="explanation-block">
          <div class="explanation">
            <div class="explanation-header flex">
              <div class="explanation-title">Write</div>
            </div>
            <div class="explanation-description">
              Copywriting. Novel writing. Blog writing. You don't need to be
              alone to write. Come get it done with Cofocus.
            </div>
          </div>
        </div>
        <div class="explanation-block">
          <div class="explanation">
            <div class="explanation-header flex">
              <div class="explanation-title" style="width: 400px">Study</div>
            </div>
            <div class="explanation-description">
              Get that homework done and out of the way & finally have time for
              yourself. And then ace those tests.
            </div>
          </div>
        </div>
        <div class="explanation-block">
          <div class="explanation">
            <div class="explanation-header flex">
              <div class="explanation-title" style="width: 400px">PhD</div>
            </div>
            <div class="explanation-description">
              You've got a lot of papers to read. You've got a lot to write. Get
              your research done in company.
            </div>
          </div>
        </div>
        <div class="explanation-block">
          <div class="explanation">
            <div class="explanation-header flex">
              <div class="explanation-title" style="width: 400px">
                Side hustle
              </div>
            </div>
            <div class="explanation-description">
              With another person by your side, you can push it further, stay
              focused longer and put in the hours even when you're tired.
            </div>
          </div>
        </div>
        <div class="explanation-block">
          <div class="explanation">
            <div class="explanation-header flex">
              <div class="explanation-title" style="width: 400px">
                Administrative
              </div>
            </div>
            <div class="explanation-description">
              Send those emails. Create those invoices. Pay those bills. Do those taxes.
            </div>
          </div>
        </div>
        <div class="explanation-block">
          <div class="explanation">
            <div class="explanation-header flex">
              <div class="explanation-title" style="width: 400px">
                Plan & reflect
              </div>
            </div>
            <div class="explanation-description">
              Plan your day. Review your week. Bullet journal.
            </div>
          </div>
        </div>
        <div class="explanation-block">
          <div class="explanation">
            <div class="explanation-header flex">
              <div class="explanation-title" style="width: 400px">
                Freelance work
              </div>
            </div>
            <div class="explanation-description">
              Write code. Make some epic illustrations. Edit your videos to
              perfection.
            </div>
          </div>
        </div>
        <div class="explanation-block">
          <div class="explanation">
            <div class="explanation-header flex">
              <div class="explanation-title" style="width: 400px">
                Meditate
              </div>
            </div>
            <div class="explanation-description">
              Structure time to find calm, gain clarity and insight.
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-page-container>
</template>

<script>
import AppPageContainer from "@/components/AppPageContainer.vue";

export default {
  name: "UseCases",
  components: {
    AppPageContainer,
  },
};
</script>

<style scoped>
.link {
  color: blue;
}
.link:hover {
  text-decoration: underline;
}
.section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  align-items: center;
  padding-bottom: 80px;
  font-family: "F37 Ginger Regular", sans-serif;
  overflow-x: hidden;
}
.section {
  padding-top: 80px;
}
.section-info {
  padding: 20px 0px;
  padding-bottom: 40px;
}
.team {
  color: blue;
}
.team:hover {
  color: #000084;
}
.instruction-title {
  font-size: 68px;
  font-weight: 700;
  margin-bottom: 10px;
  text-align: center;
}
.instru-image {
  max-width: 600px;
  width: 100%;
  margin: 4px 0px;
}
.instruction,
.ps {
  font-size: 22px;
  padding: 18px 20px;
  background-color: #ffffff;
  margin: 6px 0px;
  border-radius: 8px;
  box-shadow: rgb(179 179 179 / 42%) 0px 1px 4px 0px !important;
  max-width: 600px;
  width: 100%;
}
.ps {
  box-shadow: unset !important;
  font-size: 16px;
  text-align: center;
  max-width: 500px;
  width: 100%;
  margin-bottom: 20px;
}
.cofocus-info {
  text-align: center;
  width: 620px;
  font-size: 20px;
  line-height: 28px;
  color: #333;
  margin-left: auto;
  margin-right: auto;
}
.explanation-block {
  padding: 70px 0px;
  padding-bottom: 40px;
}

.explanation-image-container {
  width: 600px;
  height: 400px;
  overflow: hidden;
  filter: drop-shadow(2px 4px 4px #1111110f);
  border-radius: 6px;
  border: 1px solid #efefef;
}
.explanation-image {
  width: 600px;
  height: 400px;
  object-fit: cover;
  zoom: 110%;
}
.explanations {
  flex-wrap: wrap;
  margin-left: auto;
  margin-right: auto;
  width: 900px;
}
.explanation {
  width: 260px;
  margin-left: 40px;
}
.explanation-header {
  align-items: flex-start;
}

.explanation-number {
  font-size: 30px;
  padding: 10px;
  border-radius: 360px;
  line-height: 30px;
  background-color: #ececec;
  width: 30px;
  height: 30px;
  text-align: center;
}

.explanation-title {
  font-size: 41px;
  width: 260px;
  line-height: 43px;
}
.explanation-description {
  font-size: 19px;
  line-height: 30px;
  padding: 10px 0px;
  color: #333;
  width: 260px;
}
</style>